export interface NavItem {
  id: string;
  label: string;
  path: string;
  icon: string;          // Lucide icon adı, string olarak
  category: 'cockpit' | 'grow' | 'climate' | 'lab' | 'system';
  kbd?: string;
  tabId?: string;        // hedef sayfanın ?tab= query param değeri
  badgeKey?: string;     // Zustand store'daki sayısal alan adı (ör: 'unreadAlertCount')
}

export const navigationSchema: NavItem[] = [
  // COCKPIT
  { id: 'dashboard', label: 'Komuta', path: '/', category: 'cockpit', icon: 'BarChart3', kbd: '1' },
  { id: 'uyarilar', label: 'Uyarılar', path: '/uyarilar', category: 'cockpit', icon: 'Bell', kbd: 'A', badgeKey: 'unreadAlertCount' },
  { id: 'analitik', label: 'Analitik', path: '/analitik', category: 'cockpit', icon: 'LineChart', kbd: '4' },

  // GROW
  { id: 'torbalar', label: 'Üretim', path: '/uretim', category: 'grow', icon: 'Package', kbd: '2', tabId: 'torbalar' },
  { id: 'receteler', label: 'Reçeteler & Spawn', path: '/uretim', category: 'grow', icon: 'FlaskConical', tabId: 'receteler' },
  { id: 'rapor', label: 'Üretim Raporları', path: '/uretim', category: 'grow', icon: 'BarChart2', tabId: 'rapor' },
  { id: 'arsiv', label: 'Hasat Arşivi', path: '/uretim', category: 'grow', icon: 'Archive', tabId: 'arsiv' },

  // CLIMATE
  { id: 'telemetri', label: 'İklim', path: '/iklim', category: 'climate', icon: 'Eye', kbd: '3', tabId: 'durum' },
  { id: 'cihaz_kontrol', label: 'Cihaz Kontrolleri', path: '/iklim', category: 'climate', icon: 'Zap' },
  { id: 'iklim_gecmis', label: 'Geçmiş Analiz', path: '/iklim', category: 'climate', icon: 'History', tabId: 'gecmis' },
  { id: 'iklim_gunluk', label: 'Günlük Özet', path: '/iklim', category: 'climate', icon: 'BookOpen', tabId: 'gunluk' },

  // LAB
  { id: 'sabah_triaj', label: 'Operasyon', path: '/operasyon', category: 'lab', icon: 'CheckSquare', kbd: '5' },
  { id: 'sterilizasyon', label: 'Sterilizasyon', path: '/operasyon', category: 'lab', icon: 'Thermometer', tabId: 'sterilizasyon' },
  { id: 'planlama', label: 'İş Akışı Planlama', path: '/operasyon', category: 'lab', icon: 'Calendar', tabId: 'planlama' },
  { id: 'kapasite', label: 'Kapasite', path: '/operasyon', category: 'lab', icon: 'Layers', tabId: 'kapasite' },
  { id: 'ai_jarvis', label: 'AI Asistan', path: '/ai', category: 'lab', icon: 'Sprout', kbd: '8' },

  // SYSTEM
  { id: 'sistem_durum', label: 'Sistem', path: '/sistem', category: 'system', icon: 'Activity', kbd: '6', tabId: 'durum' },
  { id: 'cihaz_yonetim', label: 'IoT Entegrasyon', path: '/sistem', category: 'system', icon: 'SlidersHorizontal', tabId: 'cihazlar' },
  { id: 'ayarlar', label: 'Ayarlar', path: '/ayarlar', category: 'system', icon: 'Settings', kbd: 'S' }
];
